import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5a2c9f18&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./popupConfirmDelete.styles.scss?vue&type=style&index=0&id=5a2c9f18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2c9f18",
  null
  
)

export default component.exports